<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("admin_tools.tabs.digia") }}
      UiStackItem
        UiStack(spacing="xl")
          UiStackItem
            strong {{ $t("labels.filter_by") }}
          UiStackItem
            UiStack
              UiStackItem
                label.m-0(label-for="start-date-input") {{ $t("companies.automation.start_date") }}
              UiStackItem
                UiDatePicker.filter-input(v-model="filters.date_start")
          UiStackItem
            UiStack
              UiStackItem
                label.m-0(label-for="end-date-input") {{ $t("companies.automation.end_date") }}
              UiStackItem
                UiDatePicker.filter-input(v-model="filters.date_end")
  UiCardSection
    UiTabs(
      :tabs="tabs"
      :selected="digiaTab"
      @select="onTabChange"
      skin="light"
    )
  UiCardSection
    component(
      :is="activeTab.component"
      :globalRequestFilters="globalRequestFilters"
    )
</template>

<script>
import FilesTab from "@/views/Digia/Tabs/files.vue";
import InvoicesTab from "@/views/Digia/Tabs/invoices.vue";
import CustomersTab from "@/views/Digia/Tabs/customers.vue";
import ApiCompanies from "@/api/companies.js";
import { dateToDateString } from "@/common/date_to_date_string.js";
import { addDays } from "@/common/date_utils.js";

export default {
  components: {
    FilesTab,
    InvoicesTab,
    CustomersTab,
  },

  data() {
    return {
      company: null,
      filters: {
        date_start: addDays(new Date(), -30),
        date_end: new Date(),
        files: [],
      },
    };
  },

  computed: {
    digiaTab() {
      return this.activeTab?.id;
    },

    tabs() {
      return [
        {
          id: "files",
          label: this.$t("labels.files"),
          component: FilesTab,
        },
        {
          id: "invoices",
          label: this.$t("labels.invoices"),
          component: InvoicesTab,
        },
        {
          id: "customers",
          label: this.$t("labels.customers"),
          component: CustomersTab,
        },
      ];
    },

    activeTab() {
      const index = this.tabs.findIndex(
        (tab) => tab.id === this.$route.query.digia_tab,
      );
      return index >= 0 ? this.tabs[index] : this.tabs[0];
    },

    globalRequestFilters() {
      return {
        company_id: this.$route.params.id,
        date_start: dateToDateString(this.filters.date_start),
        date_end: dateToDateString(this.filters.date_end),
      };
    },
  },

  methods: {
    buildQueryParams(params) {
      return {
        ...this.$route,
        query: {
          ...this.$route.query,
          ...params,
        },
      };
    },

    updateQueryParams(params) {
      this.$router.push(this.buildQueryParams(params));
    },

    onTabChange(tab) {
      this.updateQueryParams({ digia_tab: tab });
    },

    initCompany() {
      ApiCompanies.getCompany(this.$route.params.id).then((resp) => {
        this.company = resp.data.company;
      });
    },
  },

  created() {
    this.initCompany();
  },
};
</script>
